<template>

    <div class="question" v-if="active">

     <transition appear name="lens_unlocked"  enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">

        <div class="QA-holder horiz-flex-column-center" v-if="showQuestionHeader">

             <div class='close_btn'  v-on:click="closePrizeHandler">
                <img src="static/results/prize/unlock_close.png">
              </div>
          
          <div class='lens_holder animated delay-05s popIn fast'>
            <div class='img_holder'>
              <img :class="[{'selected':chosen}, quesObj]" :src="resultClip">
            </div>
            <div class="copy_holder">
              <h2 v-if="thisDay">CLAIM TODAY'S</h2>
              <h2 v-if="!thisDay">CLAIM YOUR</h2>
              <h3 :class="[{'selected':chosen}, quesObj]" v-html="questionText"></h3>
              <h1>NOW AVAILABLE!</h1>
              <div v-on:click="clickHandler"  :class="{'animated heartBeat slow': pulseActive}">
                  <a :href="resultLink">
                    <img class='lens_btn' src="static/results/prize/unlock_btn.png">
                  </a>
              </div>
            </div>
           

          <!--   <div style='position:absolute; display:none;'> 
              <results-answer v-for="(answerObject, index) in answerObjects" :key="index" :answerObject="answerObject"></results-answer>
            </div> -->
          </div>

        </div>

      </transition>

    </div>

</template>

<script>
/* eslint-disable */
import { eventBus } from '../EventBus';

export default {
  props: ['active'],
  created() {
    eventBus.$on('beginQuizQuestions', questionData => {
      this.questionDay = questionData.name;
      this.questionText = questionData.questionText;
      this.resultClip = questionData.resultClip;
      this.resultLink = questionData.resultLink;
      this.showWelcome = false;
      this.showQuestionHeader = true;
      this.activateQuestion = true;


      //"CLAIM YOUR" or "CLAIM TODAY'S"
      var dateToday = new Date();
      var dd = dateToday.getDate();
      if (this.questionDay == dd){
        this.thisDay = true;
      } else {
        this.thisDay = false;
      }

    });
  },
   computed: {
    quesObj: function() {
      return {
        ques1: this.currentQuestion == 1,
        ques2: this.currentQuestion == 2,
        ques3: this.currentQuestion == 3,
        ques4: this.currentQuestion == 4,
        ques5: this.currentQuestion == 5,
        ques5: this.currentQuestion == 6,
        ques5: this.currentQuestion == 7,
      };
    }
  },
  mounted() {
    // this.preload();
    this.enablePulse();
  },
  data: function() {
    return {
      pulseActive: false,
      pulseDelay: 1000,
      counter: 0,
      chosen:false,
      showQuestionHeader: true,
      thisDay: true,
      currentQuestion: 1,
      questionText: '**Lens Unlocked**',
      resultClip:  "static/results/prize/unlock_day1.png",
      resultLink:  "http://www.google.com"
    };
  },
  methods: {
    clickHandler() {
      clearTimeout(this.timeout);
    /*   this.showQuestionHeader = false;
      eventBus.showtheMenu(); */
    },  
    closePrizeHandler() {
      clearTimeout(this.timeout);
       this.showQuestionHeader = false;
      eventBus.showtheMenu();
    },
     enablePulse() {
      //console.log('activating pulse');
      this.pulseActive = !this.pulseActive;
      this.timeout = setTimeout(this.enablePulse, this.pulseDelay); 

      if (this.counter === 20) {
        clearTimeout(this.timeout);
      } else {
        this.counter+=1;
      }
    }
  },
  components: {
    /* 'results-answer': Menu */
  }
};
</script>


<style lang="scss">
// Media Query Breakpoints
$break-phone-s: only screen (max-height: 600px); //iphone 6 below
$break-phone-m: only screen and (max-height: 740px) ; //pixel2, iphone7plus
$break-phone-l: only screen and (min-height: 741px); //pixel2 XL, iphoneX
/* $break-tablet: only screen and (min-height: 901px) and (max-height: 1024px);  */

 %img{
        top: 0;
        width: 100%;
        height:100%;
        position:absolute;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: top center;
      }

 %wrapper {
      .top {
        grid-area: header;
        box-sizing: border-box;
        border-bottom: 3px solid black;
        @extend %img;
      }

      .bottom {
        grid-area: footer;
        box-sizing: border-box;
        @extend %img;
      }

    }


.horiz-flex-column-center{

      //horizontal column center
      display: flex;
      flex-direction: column;

      padding: 0;
      margin: 0;
      display: -webkit-box;
      display: -moz-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      align-items: center;
}
.question {
    position: absolute;
    margin: 0 auto;
    width: 100%;
    height: 100%;
    top: 0;
    z-index:20;

    font-family: 'SoDoSans-Bold';

    display: grid;
    grid-template-rows: 12% 76% 12%;
    justify-items: center;

    @media #{$break-phone-m} {
        grid-template-rows: 15% 80% 5%;
      }

     grid-template-areas: 
    "header"
    "copy-holder"
    "footer";

    .QA-holder{
       grid-area: copy-holder;
       z-index: 10;
       width:100%;
       height:100%;
       align-self:center;


       .lens_holder{
         width:83%;
         height:70%;
         background-color:white;
         margin-top: 35%;
        filter: drop-shadow(1px 1px 10px rgba(0,0,0,0.8));
        display:grid;
         grid-template-rows: 50% 50%;
         justify-content:center;

          .copy_holder{
            margin:auto;
            @media #{$break-phone-m} {
                margin-top:10%;
              }
          }

          .lens_btn{
            width:47%;
            height:auto;
            padding-top:5px
          }

            .img_holder{
              
              width:80%;
              height:64%;
              margin:auto;
              margin-top:20px;

              img{
                width:100%;
                height:auto;
                background-repeat: no-repeat;
                background-size: cover;
                background-position:center;
              }
            }

            h2{
              font-size: 5vw;
              letter-spacing:0.05rem;
              margin-top:0px;
              margin-bottom:0px;

               @media #{$break-phone-m} {
                font-size: 4vw;
               }
            }
            h3{
              font-size: 6vw;
               margin-top:0px;
              margin-bottom:0px;
               @media #{$break-phone-m} {
                font-size: 4.5vw;
               }
            }
            h1 {
              display: inline-block;
              color: black;
              width: 100%;
              height:auto;
              text-align: center;
              font-size: 7vw;
              width:90%;
               margin-top:0px;
              margin-bottom:0px;
              
              @media #{$break-phone-m} {
                font-size: 6.5vw;
              }
              // font-size: 1.15em;
              font-weight: bold;

              line-height: 0.95em;
              // letter-spacing: 0.05em;
              // font-style: italic;
    }
        
       }

       .Ans-holder{
          width:100%;
          height:auto;
          align-self:center;
       }

      .close_btn{
          width:5vw;
          height:auto;
          position:absolute;
          top:28%;
          right:34px;


            @media #{$break-phone-s} {
             top:26%;
            }
            @media #{$break-phone-m} {
             top:28%;
            }
          
 @media #{$break-phone-l} {
             top:23%;
            }
          img{
            width:100%;
            height:100%;
          }
        }
       

    }
  }

    .bg {
      position: absolute;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: top center;
      width: 100%;
      height: 100%;
      overflow: hidden;
      animation-duration: 0.5s;
      z-index: 0;

      background-color: #1b1b1b;

      display: grid;
      grid-template-rows: 10% auto 10%;
      justify-items: center;


      @media #{$break-phone-m} {
          grid-template-rows: 15% auto 15%;
          }

      grid-template-areas: 
      "header"
      "mid"
      "footer";

      &.question1 {
        @extend %wrapper;
      }
      &.question2 {
        @extend %wrapper;
      }
      &.question3 {
        @extend %wrapper;
      }
      &.question4 {
        @extend %wrapper;
      }

      &.question5 {
        @extend %wrapper;

      }


    } // end. question
    
.fade-transition {
  transition: opacity 0.3s ease;
}
</style>


// WEBPACK FOOTER //
// src/components/Question.vue